<template>
  <section>
    <div v-if="!items.length">{{ emptyText || 'Brak rzeczy do wyświetlenia' }}</div>
    <div v-else>
      <div class="m-timeline-1 m-timeline-1--fixed">
        <div class="m-timeline-1__items">
          <div class="m-timeline-1__marker"></div>
          <transition-group name="list">
            <component v-for="(object, index) in itemsSliced"
                       :key="object.id"
                       :object="object"
                       :class="getClass(index)"
                       :is="component"></component>
          </transition-group>
        </div>
      </div>
      <div class="row">
        <div class="col d-flex">
          <button type="button" class="btn btn-sm m-btn--custom m-btn--pill btn-ls mx-auto"
                  :disabled="!isThereMore"
                  @click="showMore">Załaduj więcej
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Screen from "@/mixins/screen";

export default {
  name: "Timeline",
  props: {
    items: Array,
    emptyText: String,
    component: Object,
  },
  mixins: [
    Screen,
  ],
  data() {
    return {
      showOnPage: 2,
    }
  },
  methods: {
    isFirst(id) {
      return this.items[0].id === id
    },
    showMore() {
      this.showOnPage += 2
    },
    getClass(index) {
      const isRight = index % 2 || this.isMobile;

      return {
        'm-timeline-1__item--first': index === 0,
        'm-timeline-1__item--right': isRight,
        'm-timeline-1__item--left': !isRight,
      }
    }
  },
  computed: {
    itemsSliced() {
      return this.items.slice(0, this.showOnPage)
    },
    isThereMore() {
      return this.showOnPage < this.items.length;
    }
  },
}
</script>

<style scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
  z-index: 1;
}

.list-enter-active, .list-leave-active {
  transition: all 1s;
  z-index: 1;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
  z-index: 1;
}
</style>
